import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationCapChart } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	Collapse,
	Group,
	Paper,
	rem,
	SimpleGrid,
	Stack,
	Text,
	UnstyledButton,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { CapChartValueIndicator } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/CapChartValueIndicator.tsx';
import { CapChartMapShape } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/CapChartMapShape.tsx';
import { CAP_TABLE_VALUES_HELD_TYPE } from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/tableSettings.ts';

const LINE_VALUE_TYPES = [CAP_TABLE_VALUES_HELD_TYPE.SECURITIES, CAP_TABLE_VALUES_HELD_TYPE.VOTES];

export const CapChartMap = () => {
	const tCapChart = useTranslationCapChart();
	const [opened, { toggle }] = useDisclosure(true);

	return (
		<Paper w={236} bd="1px solid gray.2" radius={8} px={12} pt={10} pb={12}>
			<UnstyledButton w="100%" onClick={toggle} aria-expanded={opened}>
				<Group justify="space-between" wrap="nowrap">
					<Text size="B6Bold" c="dark.8">
						{tCapChart('map.title')}
					</Text>
					<Icon
						variant="caret-down"
						size="lg"
						style={{
							transform: opened ? 'rotate(180deg)' : undefined,
							transition: 'transform 150ms ease',
						}}
					/>
				</Group>
			</UnstyledButton>

			<Collapse in={opened}>
				<Stack gap={12} pt={12}>
					<SimpleGrid cols={2} spacing={4} verticalSpacing={4}>
						<CapChartMapShape
							iconVariant="triangle"
							text={tCapChart('map.partnership')}
						/>
						<CapChartMapShape iconVariant="square" text={tCapChart('map.company')} />
						<CapChartMapShape iconVariant="oval" text={tCapChart('map.other')} />
						<CapChartMapShape iconVariant="pentagon" text={tCapChart('map.trusts')} />
						{/*todo: To be added later on*/}
						{/*<CapChartMapShape iconVariant="triangle-with-circle" text={tCapChart('map.passthrough')} />*/}
					</SimpleGrid>

					<Stack gap={6}>
						<Text fz="sm" fw={600} lh={rem(16)} c="gray.9">
							{tCapChart('map.line_values')}
						</Text>
						<Group gap={12}>
							{LINE_VALUE_TYPES.map((valuesHeldType) => (
								<Group key={valuesHeldType} gap={6} wrap="nowrap">
									<CapChartValueIndicator valuesHeldType={valuesHeldType} />
									<Text fz="sm" lh={rem(16)} c="dark.8">
										{valuesHeldType === CAP_TABLE_VALUES_HELD_TYPE.VOTES
											? tCapChart('values.votes')
											: tCapChart('values.units')}
									</Text>
								</Group>
							))}
						</Group>
					</Stack>
				</Stack>
			</Collapse>
		</Paper>
	);
};
